<script setup lang="ts">
/**
 * DraftBadge —— 预览模式下「草稿」Section 的角标（F08）。
 *
 * 触发条件：`section.publishStatus === 'Draft'` 且前台处于 Preview Mode
 * （`store.state.isPreview`）。普通访客态永不渲染（公共聚合只返 Published，
 * 后端 B13 契约保证），故本组件不自带 isPreview 守卫——由调用方（SectionCard
 * / GridItem 壳）在 `v-if` 同时判定 isPreview && Draft 才挂载，避免壳里
 * 重复读 store。
 *
 * 文案走 Copy Catalog `copy.preview.draftBadge`（F08 acceptance）；
 * 颜色走 `--color-draft-badge-bg` token（ADR-0009 禁硬编码颜色）。
 */
import { copy } from '@/i18n/zh-CN';
</script>

<template>
  <span :class="$style.badge" data-testid="draft-badge">{{ copy.preview.draftBadge }}</span>
</template>

<style module>
.badge {
  display: inline-block;
  background: var(--color-draft-badge-bg);
  color: var(--color-bg-primary);
  font-size: var(--font-size-sm);
  font-weight: 700;
  line-height: 1;
  padding: 2px var(--space-1);
  border-radius: var(--radius-sm);
  white-space: nowrap;
}
</style>
